import React from 'react';
import {Skeleton, Stack} from "@mui/material"

interface ClassifierMetricsSkeletonProps {
    classCount: number
}

function ClassifierMetricsSkeleton({classCount}: ClassifierMetricsSkeletonProps) {
    const rows = Math.max(classCount, 2)
    return (
        <Stack spacing={1.5}>
            <Stack direction="row" spacing={1}>
                {Array.from({length: rows}).map((_, index) =>
                    <Skeleton key={index} variant="rounded" width={110} height={24}/>,
                )}
            </Stack>
            <Skeleton variant="text" width={300}/>
            <Skeleton variant="rounded" height={(rows + 1) * 37 + 16}/>
        </Stack>
    );
}

export default ClassifierMetricsSkeleton;
